import store from "@/store";
import { io } from "socket.io-client";
import { eventBus } from "@/eventBus.js";
import { ensureSocketListeners, removeAllSocketListeners } from "./attendances";
import {
  ensureAudienceSocketListeners,
  removeAllAudienceSocketListeners,
} from "./audiences";
import {
  ensureEntitiesSocketListeners,
  removeAllEntitiesSocketListeners,
} from "./entities";
import {
  ensureAppointmentSocketListeners,
  removeAllAppointmentSocketListeners,
  subscribeDesk,
  unsubscribeDesk,
} from "./appointments";
import { getCounters } from "@/services/counters";

let socket = null;
let subscribedDeskIDs = [];

export const connectSocket = () => {
  if (socket) {
    console.warn("Socket já está conectado.");
    return socket;
  }

  const now = Date.now();
  const ttl = 3600 * 1000 * 8;
  const isExpirated =
    (store?.state?.socketSession?.connectedAt || 0) + ttl < now;

  const options = {
    auth: {
      token: store.getters.accessToken,
      xApiKey: process.env.VUE_APP_API_KEY,
    },
    ...(store?.state?.socketSession?.sessionID &&
      !isExpirated && {
        query: { sessionID: store?.state?.socketSession?.sessionID },
      }),
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  };

  socket = io(process.env.VUE_APP_SOCKET_URL, options);

  socket.on("connect", () => {
    console.log("Socket conectado!");
    ensureSocketListeners();
    ensureAudienceSocketListeners();
    ensureEntitiesSocketListeners();
    ensureAppointmentSocketListeners();
    subscribeToUserDesks();

    eventBus.$emit("socket-reconnected");
  });

  socket.on("disconnect", () => {
    console.log("Socket desconectado!");
    removeAllSocketListeners();
    removeAllAudienceSocketListeners();
    removeAllEntitiesSocketListeners();
    removeAllAppointmentSocketListeners();
    subscribedDeskIDs = [];
  });

  socket.on("socket:connected", (data) => {
    store.dispatch("setSocketSession", data);
  });

  // Adicione outros listeners se necessário
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    console.log("Socket foi desconectado.");
    socket = null;
  } else {
    console.warn("Nenhum socket para desconectar.");
  }
};

export const getSocket = () => {
  if (!socket) {
    console.warn("Socket não está conectado.");
  }

  return socket;
};

async function subscribeToUserDesks() {
  try {
    const user = store?.state?.user;
    if (!user?._id) return;

    const { data } = await getCounters({
      personID: user._id,
      limit: 100,
      counterType: "cabinet",
    });

    if (!data?.length) return;

    const deskIDs = data.map((desk) => desk._id);

    deskIDs.forEach((deskID) => {
      if (subscribedDeskIDs.includes(deskID)) return;

      subscribeDesk({
        data: { deskID },
        callback: (error) => {
          if (error) {
            console.error(`Erro ao se inscrever no desk ${deskID}:`, error);
            return;
          }
          subscribedDeskIDs.push(deskID);
        },
      });
    });
  } catch (error) {
    console.error("Erro ao buscar desks do usuário:", error);
  }
}

export function unsubscribeFromAllDesks() {
  subscribedDeskIDs.forEach((deskID) => {
    unsubscribeDesk({
      data: { deskID },
      callback: (error) => {
        if (error) {
          console.error(`Erro ao sair do desk ${deskID}:`, error);
        }
      },
    });
  });
  subscribedDeskIDs = [];
}

export function getSubscribedDeskIDs() {
  return [...subscribedDeskIDs];
}
